<template lang='pug'>
  v-dialog(v-model="dialog" persistent max-width="500")

    template(v-slot:activator="{ on, attrs }")
      v-icon(
        @click="showAlert"
        class="mr-2"
        slot="activator" 
        small 
        title='Withdraw' 
        color="red" 
        v-bind="attrs"
        v-on="on"
      ) cancel

    v-card
      v-card-title(class="headline grey lighten-3 mb-3") Withdraw Memo
      div(class="pl-6")
        span.red--text *
        b(class="pt-3" style="font-size: 14px;") {{currentStatusText}}
      p(class="pl-6 pt-3" style="font-size: 14px;") 
        span.red--text *
        | Leave a comment for the memo
      v-card-text
        v-layout(wrap)
          v-flex(xs12)
            v-textarea(
              v-model="comment"
              filled
              label="Description"
              counter="150"
              :rules="[rules.length(150)]"
            )
            
      v-card-actions.pb-5
        v-spacer
        v-btn(
          depressed
          @click="dialog = false"
          class="pl-4 pr-4"
        )
          | Close

        v-btn(
          :disabled="!isInputValid" 
          color="blue-secondary" 
          depressed 
          @click="submit"
          class="pl-4 pr-4"
        ) Submit

    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )

</template>

<script>
import axios from "axios";
import * as i18n from "../data/i18n.json";
import { mapState } from "vuex";
export default {
  name: 'WithdrawDialog',
  props: {
    imId: String,
    im: Object,
    creator: Boolean
  },
  data: () => ({
    dialog: false,
    currentStatusText: '',
    duplicate: false,
    i18n: i18n.default,
    overlay: false,
    comment: '',
    rules: {
      length: len => v => (v || '').length <= len || `Comment must be less than 150 characters`,
    },
  }),
  computed: {
    isInputValid() {
      return this.comment != '' && this.comment.length <= 150
    }
  },
  methods: {
    showAlert() {
      //- alert('Heyy1y');
      setTimeout(()=> {
        this.currentStatusText = ''
        this.dialog = false
        let token = localStorage.getItem("token");
          axios({
              method: "get",
              url: process.env.VUE_APP_API_OLD+`/api/requests/${this.imId}`,
              headers: { Authorization: `Bearer ${token}` },
          }).then(res => {
              console.log(res.data[0])
              let memoDTL = res.data[0]
              let status = this.i18n.status[memoDTL.imStatus].name
              // PREVENT REJCTED, FULLY APPROVED, WD MEMO FOR BEING RE-WD
              if ([4, 9, 5, 8].includes(memoDTL.imStatus)) {
                this.currentStatusText = `This Memo Already Been ${status}`
                this.$toasted.error(this.currentStatusText, { icon: 'error' });
                return
              } else {
                // CHECK IF CREATOR
                if (memoDTL.userId == this.$store.state.dataUsers.user._id) {
                  // CHECK IF MEMO DRAFT
                  if (memoDTL.imStatus == 1) this.currentStatusText = `This Memo Currently "${status}"`
                  // CHECK IF MEMO REVIEWED BY SOME1
                  else if (memoDTL.imStatus == 3) this.currentStatusText = `This Memo Currently "${status}" By ${memoDTL.imUseAlias ? memoDTL.imReturn[memoDTL.imReturn.length-1].alias : memoDTL.imReturn[memoDTL.imReturn.length-1].name}`
                  // CHECK IF MEMO ON GOING
                  else if (memoDTL.imStatus != 1 && memoDTL.imStatus != 3) {
                    for (let i in memoDTL.imWorkflow) if (memoDTL.imWorkflow[i].status ==9 ) {
                      this.currentStatusText = `This Memo Currently "${status}" By ${memoDTL.imUseAlias ? memoDTL.imWorkflow[i].alias:  memoDTL.imWorkflow[i].name}`
                      break;
                    }
                  }
                // THIS ELSE FOR APPROVER THAT ABLE TO WD MEMO #SOMEHOW 
                } else {
                  // CHECK IF MEMO REVIEWED BY SOME1
                  if (memoDTL.imStatus == 3) this.currentStatusText = `This Memo Currently "${status}" By ${memoDTL.imUseAlias ? memoDTL.imReturn[memoDTL.imReturn.length-1].alias : memoDTL.imReturn[memoDTL.imReturn.length-1].name}`
                  if (memoDTL.imStatus == 4) this.currentStatusText = "Failed, memo has been processed"
                  if (memoDTL.imStatus == 5) this.currentStatusText = "Failed, memo has been processed"
                  if (memoDTL.imStatus == 8) this.currentStatusText = "Failed, memo has been processed"
                  // CHECK IF MEMO ON GOING
                  else if (memoDTL.imStatus != 1 && memoDTL.imStatus != 3) {
                    for (let i in memoDTL.imWorkflow) if (memoDTL.imWorkflow[i].status ==9 ) {
                      this.currentStatusText = `This Memo Currently "${status}" By ${memoDTL.imWorkflow[i].name}`
                      break;
                    }
                    this.$toasted.error(this.currentStatusText, { icon: 'error' });
                    return
                  }
                }
              }
              this.dialog = true
              return
          }).catch((e)=> console.log(e))
      
      },10)
    },
    async submit() {

      try {
        let token = localStorage.getItem("token");
        const d = await axios({
            method: "get",
            url: process.env.VUE_APP_API_OLD+`/api/requests/${this.imId}`,
            headers: { Authorization: `Bearer ${token}` },
        })
        const memoDTL = d.data[0]
        // IS NOT A CREATOR AND CURRENTLY NOT NEED REVIEW (CAN BE WD BY SPECIFIC APPV)
        if (memoDTL.userId != this.$store.state.dataUsers.user._id && memoDTL.imStatus != 3) {
          this.$toasted.error("Failed, memo has been processed", { icon : 'check_circle'});
          return
        }
      let person = ''
      if (this.im.imStatus == 3) person = this.im.imReturn[this.im.imReturn.length-1]
      axios.put(process.env.VUE_APP_API_OLD+`/api/withdraw/requests`, {_id: this.imId, user_bu: this.$store.state.dataUsers.user._id, comment: this.comment, person})
        .then((res) => {
            this.$toasted.error("Memo has been success withdraw", { icon : 'check_circle'});
            this.dialog = false
            location.reload();

        }).catch((err) => {
          if (err.response.data.message) {
            this.$toasted.error(err.response.data.message, { icon: 'error' });
          } else if (err.response.data.error) {
            this.$toasted.error(err.response.data.error, { icon: 'error' });
          } else {
            this.$toasted.error(err, { icon: 'error' });
          }
        });
      } catch (e) {
        this.$toasted.error(e, { icon: 'error' });
      }

    }
  }
};
</script>
<style scoped>
    i.notif{
        margin-left: 1rem;
        font-size: 50px !important;
        color: #D42A2A !important;
    }
</style>
